module.exports = __webpack_public_path__ + "img/law4-m@1.d4e1f24f.webp";